import state from "@/stores/chat/state.js"
import mutations from "@/stores/chat/mutations.js"
import actions from "@/stores/chat/actions.js"

export default {
  state,
  mutations,
  actions,
}
